import CallContext from './CallContext';

const CallConsumer = CallContext.Consumer;

export default CallConsumer;
